/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Value4Inputs */

const en_coinvestments_lpdealoverviewcontent_value4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Value4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Value4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_value4 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Value4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Value4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_value4(inputs)
});
export { coinvestments_lpdealoverviewcontent_value4 as "coInvestments_lpDealOverviewContent_value" }